import React from 'react';
import { Save } from 'lucide-react';

interface AIPrompts {
  companySummary: string;
  recommendations: string;
  digitalScore: string;
}

interface AiPromptsSectionProps {
  aiPrompts: AIPrompts;
  setAiPrompts: React.Dispatch<React.SetStateAction<AIPrompts>>;
  onSave?: () => void;
}

const AiPromptsSection: React.FC<AiPromptsSectionProps> = ({ 
  aiPrompts, 
  setAiPrompts,
  onSave
}) => {
  const handleSave = () => {
    if (onSave) onSave();
  };

  return (
    <div className="bg-white rounded-lg shadow mb-8">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4">Prompts IA</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Prompt résumé entreprise</label>
            <textarea
              value={aiPrompts.companySummary}
              onChange={e => setAiPrompts({ ...aiPrompts, companySummary: e.target.value })}
              rows={4}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Prompt recommandations</label>
            <textarea
              value={aiPrompts.recommendations}
              onChange={e => setAiPrompts({ ...aiPrompts, recommendations: e.target.value })}
              rows={4}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Prompt score et profil digital</label>
            <textarea
              value={aiPrompts.digitalScore}
              onChange={e => setAiPrompts({ ...aiPrompts, digitalScore: e.target.value })}
              rows={4}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <button 
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
            onClick={handleSave}
          >
            <Save className="mr-2" size={18} />
            Sauvegarder les prompts IA
          </button>
        </div>
      </div>
    </div>
  );
};

export default AiPromptsSection;
export type { AIPrompts };
